import React, { useState, useEffect, useRef, useCallback } from "react";
import "./LandingPage.css";
import { config } from "../config";
import { Link } from "react-router-dom";
import GoogleButton from "../components/GoogleAuth";
import { analytics } from "../components/firebase";
import { logEvent } from "firebase/analytics";
import ReactGA from "react-ga4";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Premium from "./Buypremium";
const LandingPage = () => {
  const currentYear = new Date().getFullYear();
  const googleanalytics = process.env.REACT_APP_GOOGLE_ANALYITCS_ID;
  const googleAuthRef = useRef(null);
  const menuRef = useRef(null);
  const dropdownRef = useRef(null);
  React.useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
    logEvent(analytics, "landingpage_opened");
  }, [config.color]);

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    section.scrollIntoView({ behavior: "smooth" });
  };

  const [plans, setPlans] = useState([]);

  useEffect(() => {
    const fetchDodoPlans = async () => {
      try {
        const response = await fetch(`${config.baseURL}/get_dodo_plans.php`);
        if (!response.ok) throw new Error("Failed to fetch PayPal plans");
        const data = await response.json();
        const transformedPlans = data.items.map((items) => {
          return {
            id: items.product_id,
            name: items.name,
            currency: "USD",
            amount: items.price,
            interval:
              items.name === "Weekly"
                ? "1"
                : items.name === "Monthly"
                ? "2"
                : "2",
            intervalCount: items.name || 1,
          };
        });
        setPlans(transformedPlans);
        logEvent(analytics, "fetch_paypal_plans_FacelessVideo", {});
      } catch (err) {
      } finally {
      }
    };

    fetchDodoPlans();
  }, []);

  const handleSubscribe = async (selectedPlanId) => {
    logEvent(analytics, "Subscribe_button_clicked", {
      plan_id: selectedPlanId,
    });
    ReactGA.event({
      category: "Subscription",
      action: "Clicked Subscribe on Landing Page legal doc",
      label: selectedPlanId,
    });

    try {
      localStorage.setItem("selectedPlanIdForReuse", selectedPlanId);

      const response = await fetch(`${config.baseURL}/validate_token.php`, {
        method: "GET",
        credentials: "include",
      });

      const data = await response.json();

      if (
        response.status !== 200 ||
        data.message === "Invalid token" ||
        data.error === "Wrong number of segments"
      ) {
        googleAuthRef.current.login();
        return;
      }

      const userEmail = data.user.email;

      const redirectUrl = `https://checkout.dodopayments.com/buy/${selectedPlanId}?quantity=1&redirect_url=https://legaldocumentgenerator.com/Dashboard&email=${encodeURIComponent(
        userEmail
      )}`;
      window.open(redirectUrl, "_blank");
    } catch (error) {
      console.error("Error while validating token:", error);
      alert("An error occurred. Please try again later.");
      logEvent(analytics, "Error came while subscribing landing page", {
        button_name: "landingPage_FacelessVideo",
      });
    }
  };

  const checkAndSubscribeOnLoad = () => {
    const selectedPlanId = localStorage.getItem("selectedPlanIdForReuse");

    if (selectedPlanId) {
      handleSubscribe(selectedPlanId);

      localStorage.removeItem("selectedPlanIdForReuse");
    }

    window.onload = null;
  };

  checkAndSubscribeOnLoad();

  const [user, setUser] = useState(null);

  const checkUserSession = useCallback(async () => {

    try {
      const response = await fetch("/validate_token.php", {
        method: "GET",
        credentials: "include",
      });

      const data = await response.json();
      if (data.user) {
        setUser((prevUser) => prevUser || data.user);
      } else {
        setUser(null);
      }
    } catch (error) {
      
      setUser(null);
    }
  }, [setUser]);

  useEffect(() => {
    checkUserSession();
  }, [checkUserSession]);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
    logEvent(analytics, "login_success_legal_doc ");
    checkAndSubscribeOnLoad();
  };

  const handleLoginFailure = () => {
    logEvent(analytics, "login_failure_legal_doc");
    setUser(null);
  };

  const navigate = useNavigate();

  

  return (
    <>
      <Helmet key="landing">
        <title>
          Ai Legal Document Generator | The Best AI Tool for Legal Document
          generator
        </title>

        <meta name="description" content="LegalDocumentGenerator.com is your one-stop solution for fast, reliable, and customizable legal documents. Whether you need contracts, agreements, wills, NDAs, or business-related forms, we’ve got it covered. Our AI-powered platform ensures legally accurate and professionally formatted documents tailored to your specific needs. What We Offer: ✅ All Legal Document Types: Contracts, Leases, Wills, Business Agreements, and more. ✅ Customizable Templates: Fill in your details and generate instantly. ✅ AI-Assisted Drafting: No legal jargon—just easy-to-understand forms. ✅ Lawyer-Approved: Ensuring compliance with legal standards. ✅ Safe & Secure: Your data is encrypted and protected. Why Choose Us? 🚀 Fast Generation – Get your legal documents in just a few clicks. 🔒 Affordable – Pay per document or choose from subscription plans. 📋 Always Updated – We stay current with the latest legal standards."/>
    <meta name="keywords" content="generate legal documents online, legal document generator, create legal documents online, AI legal document templates, customizable legal forms, online contract generator, NDA template generator, lease agreement creator, will and testament generator, legal paperwork automation, document management software online, business form templates, instant legal form creation, legal compliance templates, business agreement template, employment contract template, AI-powered legal document automation, contract review software, no-code legal workflows, regulatory compliance solutions, legal analytics tools, data privacy agreements, automated contract management, collaborative legal billing, document management systems for law firms, cybersecurity legal solutions"/>


        <link rel="canonical" href="https://legaldocumentgenerator.com/" />
      </Helmet>
      <Header />
      <div className="landing-page">
        <div className="Section_hero">
          <div className="title_hero">
            Secure, Accurate, and Effortless <br />
            Legal Document Generation!
          </div>
          <button
            className="button_hero"
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            Visit Dashboard
          </button>
          <GoogleButton
            id="LandingPageLogin"
            ref={googleAuthRef}
            onLoginSuccess={handleLoginSuccess}
            onLoginFailure={handleLoginFailure}
          />
          <img src={config.Heroimage} alt="" />
        </div>

        <div className="section_2">
          <div className="section_2_title">How it work</div>

          <div className="section_2_subSection">
            <div className="section_2_stepRow">
              <div className="stepCol left">
                <img
                  src={config.step1}
                  alt="steps detail 1"
                  className="section_2_img"
                />
              </div>
              <div className="stepCol center">
                <div className="section_2_number">01</div>
              </div>
              <div className="stepCol right">
                <div className="section_2_textBox">
                  <div className="section_2_textHeading">
                    Upload your prompt
                  </div>
                  <div className="section_2_textParagraph">
                    Start by entering your legal query or prompt—whether it's a
                    lease agreement, employment contract, or any other document.
                    Our smart system will help you kickstart the process
                    instantly.
                  </div>
                </div>
              </div>
            </div>

            <div className="section_2_stepRow">
              <div className="stepCol left">
                <div className="section_2_textBox">
                  <div className="section_2_textHeading">
                    Customize your Keywords
                  </div>
                  <div className="section_2_textParagraph">
                    Tailor the document with keywords that reflect your unique
                    needs. Choose from commonly used legal phrases or add your
                    own terms to generate a highly personalized draft.
                  </div>
                </div>
              </div>
              <div className="stepCol center">
                <div className="section_2_number">02</div>
              </div>
              <div className="stepCol right">
                <img
                  src={config.step2}
                  alt="steps detail 2"
                  className="section_2_img"
                />
              </div>
            </div>

            <div className="section_2_stepRow">
              <div className="stepCol left">
                <img
                  src={config.step3}
                  alt="steps detail 3"
                  className="section_2_img"
                />
              </div>
              <div className="stepCol center">
                <div className="section_2_number">03</div>
              </div>
              <div className="stepCol right">
                <div className="section_2_textBox">
                  <div className="section_2_textHeading">Select the Length</div>
                  <div className="section_2_textParagraph">
                    Whether it's a brief agreement or a detailed legal draft,
                    you can pick the level of detail and length to match your
                    purpose. Let our AI handle the formatting and structuring.
                  </div>
                </div>
              </div>
            </div>

            <div className="section_2_stepRow">
              <div className="stepCol left">
                <div className="section_2_textBox">
                  <div className="section_2_textHeading">
                    Edit, Download & Share
                  </div>
                  <div className="section_2_textParagraph">
                    Your AI-generated legal document is ready in seconds. Just
                    copy the text and share or paste it wherever you need.
                  </div>
                </div>
              </div>
              <div className="stepCol center">
                <div className="section_2_number">04</div>
              </div>
              <div className="stepCol right">
                <img
                  src={config.step4}
                  alt="steps detail 4"
                  className="section_2_img"
                />
              </div>
            </div>
          </div>
        </div>

        <Premium showBackButton={false} showLeftPanel={false} />
      </div>

      <div className="footer">
        <div className="footer_top">Ai Legal Document Generator</div>
        <div className="footer_links">
          <div className="footer_column">
            <div className="footer_column_title">Home</div>
            <div
              onClick={() => {
                navigate("/dashboard");
              }}
            >
              Dashboard
            </div>
            <div
              onClick={() => {
                navigate("/premium");
              }}
            >
              Premium
            </div>
            <div
              onClick={() => {
                navigate("/blog");
              }}
            >
              Blogs
            </div>
          </div>
          <div className="footer_column">
            <div className="footer_column_title">About</div>
            <div
              onClick={() => {
                navigate("/terms&condition");
              }}
            >
              Terms & Conditions
            </div>
            <div
              onClick={() => {
                navigate("/privacy");
              }}
            >
              Privacy Policy
            </div>
            <div
              onClick={() => {
                navigate("/refundpolicy");
              }}
            >
              Refund Policy
            </div>
          </div>
          <div className="footer_column">
            <div className="footer_column_title">Contact</div>
            <div>Contact us</div>
            <a href="mailto:speedapps1010@gmail.com" className="no-link">
              <p>speedapps1010@gmail.com</p>
            </a>
            <p>8176851179</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
